// extracted by mini-css-extract-plugin
export default {"dialogPaper":"TopicDetailsModal_dialogPaper__cAQZ0","titleBox":"TopicDetailsModal_titleBox__8WWeb"};